import { createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import { organisationsApi, IOrganisation as IOrganisationAPI } from "engine/api/organisations";
import { routes } from "engine/routes";
import { push } from "redux-first-history";

export const getOrganisations = createAsyncThunk<IOrganisationAPI[], string | undefined>(
  "organisations/getAll",
  async (active, { rejectWithValue }) => {
    try {
      const { data } = await organisationsApi.getOrganisations(active);

      return data;
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const getOrganisationById = createAsyncThunk<IOrganisationAPI, string>(
  "organisations/getOrganisationById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await organisationsApi.getOrganisationById(id);

      return data;
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const addOrganisation = createAsyncThunk<any, IOrganisationAPI>(
  "organisations/addOrganisation",
  async (organisation, { rejectWithValue, dispatch }) => {
    try {
      const response = await organisationsApi.addOrganisation(organisation);

      if (response.status === 200 || response.status === 201) {
        message.success("Organisation created successfully");
        dispatch(push(routes.dashboard.organisations().overview));
      }

      return {};
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const updateOrganisation = createAsyncThunk<any, IOrganisationAPI>(
  "organisations/updateOrganisation",
  async (organisation, { rejectWithValue }) => {
    try {
      const response = await organisationsApi.updateOrganisation(organisation);

      if (response.status === 200) {
        message.success("Organisation updated successfully");
      }

      return {};
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

export const deleteOrganisations = createAsyncThunk<any, string[]>(
  "organisations/deleteOrganisations",
  async (ids, { rejectWithValue, dispatch }) => {
    try {
      const response = await organisationsApi.deleteOrganisations(ids);

      if (response.status === 200) {
        message.success("Organisation(s) removed successfully");
        dispatch(getOrganisations());
        dispatch(push(routes.dashboard.organisations().overview));
      }

      return {};
    } catch (error) {
      return rejectWithValue("error happened");
    }
  },
);

